import { useLoadScript } from "@react-google-maps/api";
import { useConfig } from "@context/config";
export var LIBRARIES = ["places"];
export var useGoogleMaps = function () {
    var googleMapsApiKey = useConfig().googleMapsApiKey;
    return useLoadScript({
        id: "google-map-script",
        googleMapsApiKey: googleMapsApiKey,
        libraries: LIBRARIES,
    });
};
